export type Listener<T> = (data: T) => void

export class PubSub<T> {
	listeners = new Set<Listener<T>>()

	subscribe = (listener: Listener<T>) => {
		this.listeners.add(listener)
		return () => {
			this.listeners.delete(listener)
		}
	}

	publish = (data: T) => {
		this.listeners.forEach((listener) => listener(data))
	}
}
